import { useState } from "react";
import styled from "styled-components";

import * as Types from "Types";

const Wrap = styled.div<Types.Default>`
   height: 100%;
   & img {
      max-height: 100%;
   }

   ${({ css }) => css}
`;

export default function RowIcon(props: Types.Atoms.RowIcon) {
   const [source, setSource] = useState("");
   import(`assets/images/row${props.rowNumber}.png`).then(function (m) {
      setSource(m.default);
   });

   return (
      <Wrap {...props}>
         <img src={source} alt="" />
      </Wrap>
   );
}
